<template>
  <div class="comp-play-slider">
    <div class="slider-position-text">
      {{((1 / frameRate) * (currentFrame - 1)).toFixed(2)}}
    </div>
    <div
    v-on:click="onClickSlider" ontouchstart=""
    v-on:mousemove="updateScreenVariables"
    v-on:mouseup="onMouseUp"
    v-on:mousedown="onMouseDown"
    class="slider-container">
      <div
      v-bind:style="{
        width: ((totalAvailableFrame - 1) / (totalFrame - 1) * 100) + '%'
      }"
      class="slider-background"></div>
      <div
      v-bind:style="{
        width: ((currentFrame - 1) / (totalAvailableFrame - 1) * 100) + '%'
      }"
      class="slider-foreground"></div>
      <div
      v-on:click="onClickDraggerable" ontouchstart=""
      v-bind:style="{
        left: ((currentFrame - 1) / (totalAvailableFrame - 1) * 100) + '%'
      }"
      class="slider-draggerable">
        <comp-icon
        v-if="isPaused"
        v-bind:icon="'play'"
        v-bind:width="14"></comp-icon>
      </div>
    </div>
    <div class="slider-position-text">
      {{((1 / frameRate) * (totalFrame - currentFrame)).toFixed(2)}}
    </div>
  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
export default {
  name: 'comp-play-slider',
  components: {
    CompIcon
  },
  props: {
    totalFrame: {
      type: Number,
      default: function () {
        return 8
      }
    },
    totalAvailableFrame: {
      type: Number,
      default: function () {
        return 0
      }
    },
    currentFrame: {
      type: Number,
      default: function () {
        return 0
      }
    },
    isPaused: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    isControllable: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    frameRate: {
      type: Number,
      default: function () {
        return 2
      }
    }
  },
  data: function () {
    return {
      isVisible: false,
      sliderWidth: 0,
      sliderScreenLeft: 0,
      sliderCurrentX: 0
    }
  },
  created: function () {
  },
  watch: {
  },
  methods: {
    onClickFrameIndex: function (frameIndex) {
      this.$emit('onClickFrameIndex', {
        frameIndex: frameIndex
      })
    },
    onClickPlay: function () {
      this.$emit('onClickPlay', null)
    },
    onClickSlider: function (event) {
      if (this.isControllable) {
        // updateSliderVariables needs to be updated always before calling fireOnClickFrameIndex
        event.stopPropagation()
        this.updateScreenVariables(event)
        this.fireOnClickFrameIndex(event)
      }
      this.$emit('onClickSlider', null)
    },
    updateScreenVariables: function (event) {
      let style = event.currentTarget.currentStyle || window.getComputedStyle(event.currentTarget, null)
      let borderLeftWidth = parseInt(style['borderLeftWidth'], 10)
      let rect = event.currentTarget.getBoundingClientRect()
      this.sliderScreenLeft = borderLeftWidth + rect.left
      this.sliderWidth = rect.width
    },
    updateSliderVariables: function (event) {
      this.sliderCurrentX = event.clientX - this.sliderScreenLeft
      if (this.sliderCurrentX <= 0) {
        this.sliderCurrentX = 0
      } else if (this.sliderCurrentX > this.sliderWidth) {
        this.sliderCurrentX = this.sliderWidth
      }
    },
    onClickDraggerable: function (event) {
      if (this.isControllable) {
        event.stopPropagation()
        this.onClickPlay()
      }
    },
    onMouseMove: function (event) {
      if (this.isControllable) {
        this.fireOnClickFrameIndex(event)
      }
    },
    onMouseDown: function (event) {
      if (this.isControllable) {
        event.stopPropagation()
        window.addEventListener('mousemove', this.onMouseMove)
        window.addEventListener('mouseup', this.onMouseUp)
      }
    },
    onMouseUp: function (event) {
      if (this.isControllable) {
        event.stopPropagation()
        window.removeEventListener('mousemove', this.onMouseMove)
        window.removeEventListener('mouseup', this.onMouseUp)
      }
    },
    fireOnClickFrameIndex: function (event) {
      this.updateSliderVariables(event)
      let targetFrameIndex = this.getClosestFrameIndex()
      this.onClickFrameIndex(targetFrameIndex)
    },
    getClosestFrameIndex: function () {
      let closestFrameIndex = 0
      // ////////////////////////////
      if (this.totalAvailableFrame > 1) {
        let frameWidth = this.sliderWidth / (this.totalFrame - 1)
        closestFrameIndex = Math.round(this.sliderCurrentX / frameWidth)
      } else if (this.totalAvailableFrame === 1) {
        closestFrameIndex = 0
      } else {
        closestFrameIndex = 0
      }
      // ////////////////////////////
      if (closestFrameIndex > (this.totalAvailableFrame - 1)) {
        closestFrameIndex = this.totalAvailableFrame - 1
      } else if (closestFrameIndex < 0) {
        closestFrameIndex = 0
      }
      // ////////////////////////////
      return closestFrameIndex
    }
  }
}
</script>

<style scoped>
.comp-play-slider {
  /* common */
  font-size: 14px;
  /* size */
  width: 100%;
  height: 1em;
  /* position */
  position: relative;
  /* alignment */
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.comp-play-slider .slider-position-text {
  /* common */
  font-size: 1em;
  /* size */
  min-width: 3em;
}

.comp-play-slider .slider-container {
  /* common */
  font-size: 14px;
  /* size */
  width: calc(100% - 1em);
  height: 1em;
  margin-right: 1em;
  /* position */
  position: relative;
}

.comp-play-slider .slider-background {
  /* common */
  background-color: hsla(0, 0%, 0%, 1);
  /* size */
  width: 100%;
  height: 0.25em;
  /* position */
  position: absolute;
  left: 0;
  top: calc(50% - 0.125em);
}
.comp-play-slider .slider-foreground {
  /* common */
  background-color: hsla(202, 100%, 50%, 1);
  /* size */
  width: 100%;
  height: 0.25em;
  /* position */
  position: absolute;
  left: 0;
  top: calc(50% - 0.125em);
}
.comp-play-slider .slider-draggerable {
  /* common */
  background-color: hsla(202, 100%, 100%, 1);
  color: #333;
  /* shape */
  border-radius: 50%;
  box-shadow: 0 0 4px 0 hsla(0, 0%, 0%, 1);
  transform-origin: left center;
  /* size */
  width: 1em;
  height: 1em;
  /* position */
  position: absolute;
  left: 0;
  top: calc(50% - 0.5em);
  /* animation */
  transition: transform .3s;
}
.comp-play-slider .slider-draggerable:hover {
  transform: scale(1.5);
}

</style>



// WEBPACK FOOTER //
// src/components/CompPlaySlider.vue